// Feature flags.
// PAYMENTS_ENABLED: passez à `true` pour réactiver le checkout Stripe et les
// CTA d'abonnement (boutons « Choisir / Acheter / Changer / Voir les abonnements »).
export const PAYMENTS_ENABLED = false;

// PHYSICAL_PASSPORT_ENABLED: le Passeport Métal physique (carte usinée, étui
// cuir, puce NFC). L'objet N'EXISTE PAS ENCORE — sa présentation et son CTA
// restent invisibles tant que ce flag est `false`, pour ne jamais annoncer en
// production un produit qu'on ne peut pas livrer.
//
// Avant de passer à `true`, il faut IMPÉRATIVEMENT :
//   1. que l'objet soit réellement commandable et livrable ;
//   2. la photographie macro (voir PHYSICAL_PASSPORT_IMAGE dans
//      components/landing/PhysicalPassportSection.jsx) — un placeholder gris
//      détruirait précisément l'effet recherché ;
//   3. décider ce que fait le lien « Demander » (formulaire, liste d'attente,
//      commande) — il ne mène nulle part aujourd'hui.
export const PHYSICAL_PASSPORT_ENABLED = false;

// OCR_ENABLED: le scan du numéro de série depuis une photo du fond de boîte.
// Passez à `true` UNIQUEMENT quand la clé backend GOOGLE_VISION_API_KEY est
// configurée en production — sinon /api/registry/ocr-serial renvoie 503 et le
// bouton « Scanner le numéro » resterait inutile. Les deux vont ensemble.
export const OCR_ENABLED = true;
